module.exports = __webpack_public_path__ + "static/media/trendrollet.62c24868.jpg";